import React, { useState, useRef } from 'react';
import Testimonial from '../elements/testimonial';
import '../../assets/css/sections/testimonials.css';
import { StarsLeft, StarsRight } from '../../assets/icons';

const testimonialData = [
    {
        image: "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=150&h=150&fit=crop&crop=face",
        rating: 5,
        comment: "E-AquaHealth has revolutionized our catfish farm in Lagos. The disease detection feature helped us prevent a major outbreak last season.",
        name: "Adebayo Kolawole",
        position: "Fish Farm Owner, Lagos"
    },
    {
        image: "https://images.unsplash.com/photo-1531123897727-8f129e1688ce?w=150&h=150&fit=crop&crop=face",
        rating: 4,
        comment: "As an aquaculture consultant in the Niger Delta, this platform has made water quality monitoring so much easier for my clients.",
        name: "Ngozi Eze",
        position: "Aquaculture Consultant, Port Harcourt"
    },
    {
        image: "https://images.unsplash.com/photo-1506277886164-e25aa3f4ef7f?w=150&h=150&fit=crop&crop=face",
        rating: 5,
        comment: "The AI-powered analytics helped us increase our tilapia yield by 40%. A game-changer for Nigerian fish farmers!",
        name: "Tunde Bakare",
        position: "Farm Director, Ibadan"
    },
    {
        image: "https://images.unsplash.com/photo-1589156229687-496a31ad1d1f?w=150&h=150&fit=crop&crop=face",
        rating: 5,
        comment: "E-AquaHealth's support team understands the unique challenges we face in Nigeria. Highly recommended for serious aquaculture businesses.",
        name: "Chidinma Nwosu",
        position: "Facility Manager, Ogun State"
    }
];

const Testimonials = () => {
    const [activeIndex, setActiveIndex] = useState(0);
    const scrollRef = useRef(null);

    const handleScroll = (direction) => {
        const container = scrollRef.current;
        const scrollAmount = container.offsetWidth;
        
        if (direction === 'left') {
            container.scrollBy({
                left: -scrollAmount,
                behavior: 'smooth'
            });
            setActiveIndex(Math.max(0, activeIndex - 1));
        } else {
            container.scrollBy({
                left: scrollAmount,
                behavior: 'smooth'
            });
            setActiveIndex(Math.min(testimonialData.length - 1, activeIndex + 1));
        }
    };

    return (
        <section className="testimonials-section">
            <div className="container">
                <span className="subtitle"><img src={StarsRight} alt="" style={{height:"15px"}} /> Testimonials <img src={StarsLeft} alt="" style={{height:"15px"}} /></span>
                <h2 className="title">What Our Clients Say</h2>

                <div className="testimonials-container">
                    <button 
                        className="scroll-button left"
                        onClick={() => handleScroll('left')}
                        disabled={activeIndex === 0}
                    >
                        ←
                    </button>

                    <div className="testimonials-scroll" ref={scrollRef}>
                        {testimonialData.map((testimonial, index) => (
                            <Testimonial
                                key={index}
                                {...testimonial}
                            />
                        ))}
                    </div>

                    <button 
                        className="scroll-button right"
                        onClick={() => handleScroll('right')}
                        disabled={activeIndex === testimonialData.length - 1}
                    >
                        →
                    </button>
                </div>

                <div className="indicators">
                    {testimonialData.map((_, index) => (
                        <span 
                            key={index}
                            className={`indicator ${index === activeIndex ? 'active' : ''}`}
                        />
                    ))}
                </div>
            </div>
        </section>
    );
};

export default Testimonials;